import {useContext} from "react";
import {PlanController} from "./PlanController";
import {PlanContext} from "./PlanContext";

export const usePlan = (): PlanController => {
  return useContext<PlanController>(PlanContext);
};
